import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {
  tryToGetInquiriesByOrganization,
} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Create a inquiry
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestCreateNewInquiry = packet => {
  return {
    type: 'REQUEST_CREATE_NEW_INQUIRY',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveCreateNewInquirySuccess = data => ({
  type: 'RECEIVE_CREATE_NEW_INQUIRY_SUCCESS',
  data
})

export const receiveCreateNewInquiryFail = data => ({
  type: 'RECEIVE_CREATE_NEW_INQUIRY_FAIL',
  data
})

export const tryToCreateNewInquiry = packet => (dispatch, getState) => {

  dispatch(requestCreateNewInquiry(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;

  return fetch('/api/inquiries/organization/' + packet.scope, {
      method: 'post',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveCreateNewInquirySuccess(json));
      dispatch(tryToGetInquiriesByOrganization({org_id: json.scope}));
      dispatch(push('/workbench/' + json.scope + '/inquiries/' + json.id));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveCreateNewInquiryFail({errors:e, lastSubmit: packet}));
    })
}
